<template>
  <el-card class="myLesson">
    <div class="home-exam-box-head">
      <butt-tab :tabList="tabList" @tabChange="tabChange" :tabIndex="tabIndex" style="margin-left:30px"></butt-tab>
      <exam-search v-show="tabIndex!=3" @search="searchChange" style="margin-right:20px"></exam-search>
    </div>
    <div class="home-exam-box-con">
      <el-row v-loading="loading" v-show="tabIndex!=3">
        <el-col :span="4.8" v-for="(item,index) in list.data" :key="index" v-show="item.status === 1 || (item.status !=1 && item.history_count > 0)">
          <div @click="goPage(item)">
            <examCard :history_count="item.history_count" :title="item.name" :startTime="item.apply_begin_date ? item.apply_begin_date.substring(0,16) : ''" :endTime="item.apply_of_date ? item.apply_of_date.substring(0,16) : ''" :timeDuration="item.time_duration" :lessons="item.lessons" :type="item.type" :status="item.status" class="p-pointer" />
          </div>
        </el-col>
      </el-row>
      <el-row v-loading="achievementLoading" v-show="tabIndex==3">
        <el-col :span="4.8" v-for="(item,index) in lessonList" :key="index">
          <div @click="routeClick(item)">
            <lesson-exam-card :title="item.title" :time="`創建時間：${item.createdAt}`" class="p-pointer" />
          </div>
        </el-col>
      </el-row>
      <div v-if="(tabIndex != 3 && list.data && list.data.length == 0) || (tabIndex == 3 && lessonList.length == 0)" style="padding-top:20px">
        <empty title="暫無考試"></empty>
      </div>
    </div>
    <div class="pagination flex-center">
      <el-pagination v-if="pageshow" background hide-on-single-page @current-change="currentChange" :current-page="list.current_page" layout="prev, pager, next" :total="list.total" :page-size="10">
      </el-pagination>
    </div>
  </el-card>
</template>
<script>
import examSearch from '@p/components/exam/search'
import buttTab from '@p/components/varietyTab/buttTab'
import lessonExamCard from '@p/components/lessonExamCard';
import examCard from '@p/components/examCard';
import empty from '@p/components/contentEmpty';
export default {
  components: { examSearch, buttTab, lessonExamCard, examCard, empty },
  data () {
    return {
      lesson: 100,
      loading: false,
      achievementLoading: false,
      tabIndex: 0,
      tabList: [
        { label: '已結束', type: 'completed', icon: 'el-icon-success', color: 'color:rgba(51,51,51,0.5)' },
        { label: '考試中', type: 'progress', icon: 'el-icon-edit', color: 'color:#4D8EF6' },
        { label: '未開始', type: 'not_start', icon: 'el-icon-time', color: 'color:#F7971E' },
        // {label: '成績',type:'',icon:'el-icon-time',color:'color:#F7971E'},
      ],
      list: {},
      search: '',
      lessonList: [],
      pageshow: true
    }
  },
  created () {
    this.initData();
  },
  methods: {
    async initData (status = this.tabList[this.tabIndex].type, search = this.search, page_size = 10, page = 1) {
      if (this.tabIndex != 3) {
        this.loading = true;
        await this.$http.examination.lists({ status, search, page_size, page }).then(v => {
          if (v.status === 200 && v.data.status_code === 200) {
            const examData = v.data.data
            examData.data = examData.data.filter(item => item.status === 1 || (item.status != 1 && item.history_count > 0))
            this.list = examData
          }
          this.loading = false;
        }).catch(err => { this.loading = false; })
      } else {
        this.achievementLoading = true;
        await this.$http.examination.achievement({ page: page, pageSize: page_size }).then(res => { //成绩
          if (res.status === 200) {
            let resData = res.data.data;
            let resArray = [];
            resData.data.forEach(item => {
              resArray.push({
                title: item.exam_name,
                id: item.id,
                examination_id: item.examination_id,
                exam_id: item.exam_id,
                createdAt: item.created_at
              })
            });
            this.lessonList = resArray;
            this.achievementLoading = false;
          }
        }).catch(err => { this.achievementLoading = false; })
      }
    },
    searchChange (v) {
      this.search = v;
      this.initData(undefined, v)
    },
    //分页
    currentChange (page) {
      this.initData(undefined, undefined, undefined, page)
    },
    //tab
    tabChange (v) {
      this.tabIndex = v;
      this.pageshow = false;
      this.$nextTick(() => {
        this.pageshow = true;
      });
      this.initData()
    },
    routeClick ({ id, title, exam_id, examination_id }) {
      this.$router.push({ path: '/exam/result', query: { id: id, type: 2, title, exam_id, examination_id } })
      this.$store.commit('setFirstBreadcrumb', 2)
    },
    goPage (item) {
      this.$store.commit('setFirstBreadcrumb', 2)
      this.$router.push({ path: '/exam/list', query: { type: this.tabList[this.tabIndex].type, id: item.id, index: this.tabIndex, title: item.name } })
    }
  }
}
</script>
<style lang="less" scoped>
.lesson {
  margin-bottom: 12px;
}
.home-exam {
  margin-top: 36px;
  &-box {
    min-height: 757px;
    box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
    &-head {
      height: 64px;
      background: rgba(244, 244, 249, 1);
      border-bottom: 1px solid rgba(228, 231, 237, 1);
      display: flex;
      align-items: center;
      justify-content: space-between;
      h3 {
        margin-left: 31px;
        margin-right: 22px;
        color: #333333;
        font-size: 16px;
      }
    }
    &-con {
      padding: 20px 0 30px;
      .el-col {
        margin: 0 3px;
      }
    }
  }
  .pagination {
    margin: 32px 0;
  }
}
</style>